import Cookies from 'js-cookie'

export default {

  init() {

    // prevent navigate to #
    $(document).on('click', 'a[href="#"]', function (event) {
      event.preventDefault();
    });

    // refresh page on back of history
    $(window).bind('popstate', function() {
      // noinspection SillyAssignmentJS
      window.location.href = window.location.href;
    });

    const $modalProductRemoved = $("#modal-product-removed");
    if($modalProductRemoved.length) {
      $modalProductRemoved.modal('show');
    }

    /**************************************************/
    // init privacy notify
    /**************************************************/
    this.initPrivacyNotify();


    this.initPendingCartToast();

  },

  finalize() {

  },

  initPendingCartToast() {

    const $pendingCart = $('#pendingCartToast');

    if ($pendingCart.length) {
      setTimeout(() => {
        $pendingCart.addClass('in');
      }, 2000);
    }

    $pendingCart.find('.close').on('click', () => {
      $pendingCart.removeClass('in');
    });

  },

  initPrivacyNotify() {

    const cookieName = window.DOMAIN + 'PrivacyNotify';

    $(document).on('click', '[data-acceptcookie]', function (event) {
      event.preventDefault();
      $('#privacyNotifyContainer').remove();
      Cookies.set(cookieName, '1', { expires: 180 });
    });

    if (Cookies.get(cookieName) !== '1') {
      $('#privacyNotifyContainer').show();
    } else {
      $('#privacyNotifyContainer').remove();
    }

  },

};
